
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FilePlus } from 'lucide-react';
import CreateReportForm from './CreateReportForm';

interface CreateReportDialogProps {
  trigger?: React.ReactNode;
  authorId?: string;
}

export default function CreateReportDialog({ trigger, authorId }: CreateReportDialogProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button>
            <FilePlus className="mr-2 h-4 w-4" />
            Create Report
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Create Royalty Report</DialogTitle>
          <DialogDescription>
            Create a new quarterly royalty report for an author's book.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <CreateReportForm onSuccess={() => setOpen(false)} authorId={authorId} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
